<template>
  <div class="error-reasons w-full flex flex-col">
    <!-- v-html: `result.scan_unsuccessful` carried a <br> until the latest copy
         update, and the translation side can put one back -->
    <h3 class="error-title" v-html="titleText"></h3>
    <h3 v-if="subtitle" class="error-subtitle">{{ subtitle }}</h3>
    <div class="error-items">
      <!-- a lone tile gets the full-size badge, two or more fall into the grid -->
      <div
        v-for="tile in tiles"
        :key="tile.label"
        class="error-item"
        :class="{ single: tiles.length === 1 }"
      >
        <img :src="tile.icon" alt="" />
        <span>{{ $t(tile.label) }}</span>
      </div>
    </div>
  </div>
</template>

<script>
/**
 * The "scan unsuccessful" body shared by the scanner flow (views/ShowResult)
 * and the phone flow (MobileScan2/ScanError): title, optional subtitle and a
 * two-column grid of 92px reason badges. Figma: Cloudzet-App-Mobile-Scan /
 * Mobile scan error (3285:4954), Template-Cloudzet-App-Sanne / Error-scan
 * errors (5454:20353).
 */
export default {
  name: 'ErrorReasons',
  props: {
    // defaults to result.scan_unsuccessful
    title: {
      type: String,
      default: '',
    },
    subtitle: {
      type: String,
      default: '',
    },
    // [{ icon, label }] with `label` an i18n key
    tiles: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    titleText() {
      return this.title || this.$t('result.scan_unsuccessful');
    },
  },
};
</script>

<style lang="scss" scoped>
.error-reasons {
  color: var(--color-text);
}
.error-title {
  @apply text-center mx-auto text-sm font-semibold leading-normal;
  max-width: 80%;
}
.error-subtitle {
  @apply text-center mx-auto mt-3 text-xs font-medium leading-normal;
  color: var(--color-text-muted);
}
.error-items {
  // items-start, not items-center: a two-line label makes its tile taller, and
  // centring would push the shorter tile's icon down out of line with it
  @apply flex flex-row flex-wrap items-start justify-center my-8;
}
.error-item {
  @apply w-1/2 text-center my-1;
  min-height: 120px;
  font-size: 10px;
  line-height: 1.5;
  img {
    // the error-*.svg set are fixed-size circular badges, not free illustrations
    @apply mx-auto;
    width: 92px;
    height: 92px;
  }
  span {
    @apply my-2 w-11/12 inline-block;
  }
  // a single named reason gets the whole width and the full-size badge
  &.single {
    @apply w-full my-4;
    img {
      width: 120px;
      height: 120px;
    }
  }
}
</style>
